module.exports = __webpack_public_path__ + "img/Uganda.4318be13.svg";